export const MESSAGES = {
  SAVE_AND_SEE_RESULT: 'Salvar e ver resultado',
  READ_RESOLUTION: 'Ler a resolução',
  WATCH_RESOLUTION: 'Assistir a resolução',
  YOU_GOT_IT_RIGHT: 'Você acertou!',
  YOU_GOT_IT_WRONG: 'Você errou!',
  I_DONT_KNOW: 'Não sei',
} as const;

export const ASCII_LOWERCASE_A = 97;

export const IDK_ANSWER_ID = 0;
